var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "personalMsg" } },
    [
      _c(
        "Modal",
        {
          attrs: { title: _vm.modal.title, "footer-hide": "" },
          model: {
            value: _vm.modal.visible,
            callback: function ($$v) {
              _vm.$set(_vm.modal, "visible", $$v)
            },
            expression: "modal.visible",
          },
        },
        [
          _c("IForm", {
            key: _vm.modal.visible,
            ref: "personalMsg",
            attrs: {
              "label-position": "top",
              elem: _vm.personalMsgElem,
              model: _vm.personalMsg,
              rules: _vm.personalMsgRule,
              "btn-loading": _vm.loading,
              width: 320,
              "submit-text": "保存",
              button: "",
              "button-text": "取消",
            },
            on: {
              "on-submit": _vm.handleSubmit,
              "on-click": function ($event) {
                _vm.modal.visible = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }